import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { BeRegra } from 'src/app/models/BeRegra';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-regras',
  templateUrl: './list-regras.component.html',
  styleUrls: ['./list-regras.component.css']
})
export class ListRegrasComponent implements OnInit, OnDestroy {
  public regras: BeRegra[] = [];
  public colunasListaDados: ListaDadosColuna[] = [
    {
      campo: 'noRegra',
      rotulo: 'Regra',
        tamanho: '60%',
        editavel: true,
        edicao: {
          tipoEditor: 'texto',
          validacao: {
            obrigatorio: true,
            minLength: 3,
            maxLength: 100,
          }
        }
    }
  ];
  public subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) {}

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BeRegra[]>(
      `/api/Regras`
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.regras = res ?? [];
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onDelete(regra: BeRegra) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', regra);
  }

    public onSalvarLinha(regra: BeRegra) {
      this.unsubscribe();

      const payload: any = {
        idRegra: regra.idRegra ?? null,
        noRegra: (regra.noRegra ?? '').trim(),
      };

      const requisicao = payload.idRegra
        ? this.httpClient.put<unknown>(`/api/Regras`, payload)
        : this.httpClient.post<BeRegra>(`/api/Regras`, payload);

      this.subscription = requisicao.subscribe({
        next: (res: any) => {
          this.unsubscribe();
          if (!payload.idRegra && res?.idRegra) {
            regra.idRegra = res.idRegra;
          }
          regra.noRegra = payload.noRegra;
          this.regras = [...this.regras];
          this.snackBarService.exibirSucesso(payload.idRegra ? 'Registro salvo!' : 'Registro criado!');
        },
        error: (err) => {
          this.unsubscribe();
          this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
        }
      });
    }
  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', regra: BeRegra = {} as BeRegra) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/Regras/${regra.idRegra}`),
          () => this.onDeleteConfirm(regra),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private onDeleteConfirm(res: BeRegra) {
    this.regras = this.regras.filter(regra => regra.idRegra !== res.idRegra);
    this.snackBarService.exibirSucesso('Registro excluído!');
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}
